import React, { useEffect, useState } from "react";
import MobilePage from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import AppBar from "../../Components/AppBar";
import Container from "@mui/material/Container";
import YearbookPoseSelector from "@/react/Webshop/Components/YearbookPoseSelector";
import { generatePath, useRouteMatch } from "react-router";
import BottomBar from "@/react/Webshop/Mobile/Components/BottomBar";
import useMobileRoutes from "@/react/Webshop/Mobile/hooks/useMobileRoutes";
import YearbookPoseInstructions from "@/react/Webshop/Components/YearbookPoseInstructions";
import { usePictureSet } from "@/react/Webshop/Mobile/hooks/usePictureSet";
const useStyles = makeStyles((theme) => ({
    instructionsContainer: {
        position: "sticky",
        // Appbar height. Risky to have it hardcoded here!
        top: "70px",
        zIndex: 1000,
    },
    title: {
        fontSize: "30px",
        textAlign: "center",
        color: theme.palette.primary.dark,
        marginBottom: 0,
        fontWeight: 300,
    },
    subtitle: {
        fontSize: "20px",
        textAlign: "center",
        color: theme.palette.primary.dark,
        marginTop: 0,
        fontWeight: "normal",
    },
    expiryString: {
        fontSize: "12px",
        textAlign: "center",
        color: theme.palette.primary.dark,
        marginTop: 0,
        fontWeight: 400,
    },
    icon: {
        color: theme.palette.primary.dark,
        fontSize: "65px",
    },
}));
const MyAccountYearbookPose = () => {
    const { params } = useRouteMatch();
    const { notFound, pictureSet, isLoaded } = usePictureSet(params.pictureSetUuid);
    const [currentJobYearbookPose, setCurrentJobYearbookPose] = useState(null);
    useEffect(() => {
        var _a;
        if (!pictureSet) {
            return;
        }
        const poses = (_a = pictureSet.job.yearbookPoseSelection) === null || _a === void 0 ? void 0 : _a.poses;
        if (!poses) {
            return;
        }
        const jobYearbookPose = poses.find((p) => p.uuid === params.jobPoseUuid);
        if (jobYearbookPose) {
            setCurrentJobYearbookPose(jobYearbookPose);
        }
    }, [pictureSet]);
    const classes = useStyles();
    if (!isLoaded || !pictureSet) {
        return (React.createElement("div", null,
            React.createElement(Trans, null, "Loading..")));
    }
    if (!pictureSet.job.yearbookPoseSelection) {
        return (React.createElement(MobilePage, null,
            React.createElement(AppBar, null),
            React.createElement(Container, { maxWidth: "sm" },
                React.createElement("p", null,
                    React.createElement(Trans, null, "Yearbook pose selection not available"))),
            React.createElement(GoBackBar, { pictureSet: pictureSet })));
    }
    if (pictureSet.job.yearbookPoseSelection.expired ||
        !currentJobYearbookPose) {
        return (React.createElement(MobilePage, null,
            React.createElement(AppBar, null),
            React.createElement(Container, { maxWidth: "sm" },
                React.createElement("p", null,
                    React.createElement(Trans, null, "Yearbook pose selection has expired"))),
            React.createElement(GoBackBar, { pictureSet: pictureSet })));
    }
    return (React.createElement(MobilePage, null,
        React.createElement(AppBar, null),
        React.createElement(Box, { display: "flex", justifyContent: "center" },
            React.createElement("span", { className: `material-symbols-outlined ${classes.icon}` }, "import_contacts")),
        React.createElement("h1", { className: classes.title }, currentJobYearbookPose.name),
        React.createElement("h2", { className: classes.subtitle },
            React.createElement(Trans, null, "Select yearbook pose")),
        React.createElement("h3", { className: classes.expiryString }, pictureSet.job.yearbookPoseSelection.expiryDateInfoString),
        React.createElement(Box, { className: classes.instructionsContainer, mb: 2 },
            React.createElement(YearbookPoseInstructions, { pictureSet: pictureSet, jobYearbookPose: currentJobYearbookPose })),
        React.createElement(Container, null,
            React.createElement(YearbookPoseSelector, { pictureSet: pictureSet, jobYearbookPose: currentJobYearbookPose })),
        React.createElement(GoBackBar, { pictureSet: pictureSet })));
};
const GoBackBar = ({ pictureSet }) => {
    const routes = useMobileRoutes();
    return (React.createElement(BottomBar, null,
        React.createElement(Container, null,
            React.createElement(Box, { display: "flex", justifyContent: "flex-end", py: 1 },
                React.createElement(Button, { color: "primary", variant: "contained", component: Link, to: generatePath(routes["myaccount.picturesets.pictureset"].path, {
                        uuid: pictureSet.uuid,
                    }) },
                    React.createElement(Trans, null, "Go back"))))));
};
export default MyAccountYearbookPose;
